// Font constants shared between ThemeProvider and the Branding settings UI.

export const FONT_MAP: Record<string, string> = {
  inter: "Inter",
  roboto: "Roboto",
  lato: "Lato",
  open_sans: "Open+Sans",
  tajawal: "Tajawal",
  cairo: "Cairo",
  almarai: "Almarai",
};

export const FONT_DISPLAY_NAMES: Record<string, string> = {
  inter: "Inter",
  roboto: "Roboto",
  lato: "Lato",
  open_sans: "Open Sans",
  tajawal: "Tajawal",
  cairo: "Cairo",
  almarai: "Almarai",
};
